<template>
  <div class="open-school">
    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="yxmc" label="院校名称" >
        <template slot-scope="scope">
            <router-link :to="{path:'/configuration/schoolInfo',query:{schoolName: scope.row.yxmc}}" target="_blank">{{scope.row.yxmc}}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="tjfs" label="推荐指数" > </el-table-column>
      <el-table-column prop="address" label="专业满意度">
        <el-table-column prop="zhpjfs" label="综合情况">
        </el-table-column>
        <el-table-column prop="bxtjpjfs" label="办学条件">
        </el-table-column>
        <el-table-column prop="jxzlpjfs" label="教学质量" >
        </el-table-column>
        <el-table-column prop="jypjfs" label="就业">
        </el-table-column>
      </el-table-column>
    </el-table>
    <el-pagination 
    class="pagination"
    layout="prev, pager, next"
     @current-change="handleCurrentChange"
    :total="total"
    :current-page.sync="currentPage"
    :page-size="pagesize"
    @prev-click="prevClick"
    @next-click="nextClick"
    >
  </el-pagination>
  </div>
</template>
<script>
import category from "../../../../api/adaptation.js";
export default {
  data() {
    return {
      queryData: this.$route.query,
      list: [],
      currentPage: 0,
      pagesize: 10,
      total: 0
    };
  },
  created() {
    this.getOpenCollegeDetailByCodeFn();
  },
  methods: {
    getOpenCollegeDetailByCodeFn() {
      let obj = {
        current: this.currentPage,
        size: this.pagesize,
        zydm: this.queryData.code
      } 
      category
        .getOpenCollegeDetailByCode(obj)
        .then((res) => {
          this.list = res.list;
          this.total = res.total
          console.log(this.list);
        });
    },
    prevClick () {
      this.currentPage--
      this.getOpenCollegeDetailByCodeFn()
    },
    nextClick () {
      this.currentPage++
      this.getOpenCollegeDetailByCodeFn()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getOpenCollegeDetailByCodeFn();
    },

  },
};
</script>
<style lang="less" scoped>
  .open-school {
    width: 80%;
    margin: 20px auto;
    min-height: 55vh;
    .back {
      margin: 50px 0 20px 0;
    }
    .pagination {
      text-align: center;
      margin-top: 10px;
    }
    a {
      color: #0b56b0;
    }
    a:hover {
      text-decoration: revert;
    }
  }
</style>